'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _effects = require('redux-saga/effects');

var _normalizr = require('normalizr');

var _apiHelper = require('api/api-helper');

var _requirementSetSchema = require('api/schemas/requirementSetSchema');

var _requirementSetSchema2 = _interopRequireDefault(_requirementSetSchema);

var _customersDataActions = require('actions/customersDataActions');

var _departureServicesDataActions = require('actions/departureServicesDataActions');

var _profilesDataActions = require('actions/profilesDataActions');

var _requirementDataActions = require('actions/requirementDataActions');

var _bookingServicesActions = require('../actions/bookingServicesActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchRequirementData);

// gapiBaseURL is a global (defined with webpack's definePlugin)

var filterRequirements = function filterRequirements(requirementSets) {
    return requirementSets.map(function (requirementSet) {
        // If a requirement contains an 'INTERNAL' flag, we ignore it
        requirementSet.requirements = requirementSet.requirements.filter(function (requirement) {
            return !requirement.flags.includes('INTERNAL');
        });
        return requirementSet;
    });
};

// normalizr cannot extract resource values/resource_field data the way we want, so we do it manually
function extractResourceData(requirements) {
    var resources = {};
    var toPost = {};

    (0, _keys2.default)(requirements).forEach(function (key) {
        var requirement = requirements[key];

        // Forms need to know values/tempIds/hrefs for a requirement's resource
        // NOTE: We assume that a requirement's resource fields can span across several resource types,
        //       but there can be no more than one resoure of that type (resource_name) per requirement
        var fieldValuesByResourceType = {};
        var fieldResourceHrefsByType = {};
        var toPostTempIdsByResourceType = {};
        var toPostResourceHrefsByType = {};
        var toPostValuesByResourceType = {};

        requirement.resource_fields.forEach(function (resourceField) {
            var resource = resourceField.resource;
            var resourceType = resource.resource_name;
            var fieldPath = resourceField.field; // path to field in resource (e.g. passport.name)
            // handle .[] fields
            var indexOfBrackets = fieldPath.indexOf('.[]');
            if (indexOfBrackets > -1) {
                // we assume there is no more than 1 set of '[]' in the fieldPath
                fieldPath = fieldPath.slice(0, indexOfBrackets);
            }

            // Handle Rooming and merchandise payload quirks.
            if (requirement.code == 'ROOMING_DETAILS' && resourceField.value) {
                switch (fieldPath) {
                    case 'room_mates':
                        // The rooming field "room_mates" needs to be POSTed/PATCHed as "customers"
                        // because API reasons (ask Praj)
                        fieldPath = 'customers';
                        // While we're here, we throw away
                        // the junk from the response that we don't need
                        resourceField.value = resourceField.value.map(function (field) {
                            return {
                                id: field.customer.id.toString()
                            };
                        });
                        break;
                    case 'bed_type':
                        // The "bed_type" field's value needs to be fudged to
                        // work better with the forms and PATCH/POSTing
                        resourceField.value = {
                            name: resourceField.value
                        };
                        break;
                    case 'status':
                        // "status" needs to be POSTed/PATCHed as "approved_by"
                        // because API reasons (ask Praj)
                        fieldPath = 'approved_by';
                        // Forms need more than just 'approved' because API
                        // needs to be passed in the ID of the customer when PATCHing
                        if (resourceField.value == 'Approved') {
                            resourceField.value = [{ id: requirement.customer }];
                        }
                        break;
                    default:
                        break;
                }
            }

            // SHI-1076: JACKET_SIZE is now served off `departure_services.jacket_sizes`
            // (same shape as `boots_sizes`: [{ customer: { id }, size }]) and is PATCHed
            // directly to the departure service. The block below is the legacy path for
            // the old `merchandise_services` PATCH which expected `customers: [{ id, size }]`.
            // TODO: remove once the merchandise_services path is fully retired on the backend.
            if (requirement.code == 'JACKET_SIZE' && fieldPath == 'jacket_sizes' && resourceType == 'merchandise_services' && resourceField.value) {
                fieldPath = 'customers';
                resourceField.value = resourceField.value.map(function (field) {
                    return {
                        id: field.customer.id.toString(),
                        size: field.size
                    };
                });
            }

            // if resource_field resource does not exist
            if (!resource.id) {
                // mark resourceField as having a resource which needs to be POSTed/created
                resourceField.tempId = key + '-' + resourceType;

                // extraction into what will be new resources reducer object
                toPost[resourceField.tempId] = toPost[resourceField.tempId] || {};
                toPost[resourceField.tempId][resourceField.field] = resourceField;

                // tempIds and hrefs for forms
                toPostTempIdsByResourceType[resourceType] = resourceField.tempId;
                toPostResourceHrefsByType[resourceType] = resource.href;

                // Despite the fact that a resource field needs to be POST-ed,
                // it may contain values that the form needs to display
                if (resourceField.value) {
                    toPostValuesByResourceType[resourceType] = toPostValuesByResourceType[resourceType] || {};
                    toPostValuesByResourceType[resourceType][fieldPath] = {
                        value: resourceField.value || (indexOfBrackets > -1 ? [] : ''),
                        value_hidden: resourceField.value_hidden
                    };
                }
            } else {
                // extraction into what will be new resources reducer object
                resources[resource.href] = resources[resource.href] || {};
                resources[resource.href][resourceField.field] = resourceField;

                // values and hrefs for forms
                fieldValuesByResourceType[resourceType] = fieldValuesByResourceType[resourceType] || {};

                var valueHidden = resourceField.value_hidden;
                fieldValuesByResourceType[resourceType][fieldPath] = {
                    // we want an empty string or empty array not null
                    value: resourceField.value || (indexOfBrackets > -1 ? [] : ''),
                    value_hidden: valueHidden
                };
                fieldResourceHrefsByType[resourceType] = resource.href;
            }
        });

        // Overrides
        if (requirement.applied_overrides.length === 0 && requirement.override_reasons.length > 0) {
            toPostTempIdsByResourceType.overrides = key + '-overrides';
            toPostResourceHrefsByType.overrides = gapiBaseURL + '/overrides';
        } else if (requirement.applied_overrides.length > 0) {
            requirement.applied_overrides.forEach(function (override) {
                // Override is not saved in flattened form (unlike resources above ^)
                // (there should only ever be 1 applied override per requirement...)
                fieldValuesByResourceType.overrides = override;
                fieldResourceHrefsByType.overrides = override.href;
            });
        }

        requirements[key].toPostTempIdsByResourceType = toPostTempIdsByResourceType;
        requirements[key].toPostResourceHrefsByType = toPostResourceHrefsByType;
        requirements[key].toPostValuesByResourceType = toPostValuesByResourceType;
        requirements[key].fieldValuesByResourceType = fieldValuesByResourceType;
        requirements[key].fieldResourceHrefsByType = fieldResourceHrefsByType;
    });
    return { resources: resources, toPost: toPost };
}

function fetchRequirementData() {
    var requestExtraResourceData, bookingId, authToken, locale, _ref, servicesData, _ref2, requirementData, error, requirementSets, _ref3, entities, _ref4, resources, toPost;

    return _regenerator2.default.wrap(function fetchRequirementData$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    requestExtraResourceData = true; // we only want to do this once after receiving requirement data

                case 1:
                    if (!true) {
                        _context.next = 56;
                        break;
                    }

                    _context.next = 4;
                    return (0, _effects.take)(_requirementDataActions.REQUIREMENT_DATA_REQUESTED);

                case 4:
                    _context.next = 6;
                    return (0, _effects.select)(function (state) {
                        return state.booking.id;
                    });

                case 6:
                    bookingId = _context.sent;
                    _context.next = 9;
                    return (0, _effects.select)(function (state) {
                        return state.user.authorization.token;
                    });

                case 9:
                    authToken = _context.sent;
                    _context.next = 12;
                    return (0, _effects.select)(function (state) {
                        return state.intl.locale;
                    });

                case 12:
                    locale = _context.sent;
                    _context.next = 15;
                    return (0, _apiHelper.getServicesData)(bookingId, authToken, locale);

                case 15:
                    _ref = _context.sent;
                    servicesData = _ref.servicesData;

                    if (!servicesData) {
                        _context.next = 52;
                        break;
                    }

                    _context.next = 20;
                    return (0, _effects.put)((0, _bookingServicesActions.bookingServicesDataReceived)(servicesData));

                case 20:
                    _context.next = 22;
                    return (0, _apiHelper.getRequirementData)(bookingId, servicesData.length, authToken, locale);

                case 22:
                    _ref2 = _context.sent;
                    requirementData = _ref2.requirementData;
                    error = _ref2.error;

                    if (!requirementData) {
                        _context.next = 48;
                        break;
                    }

                    _context.next = 28;
                    return (0, _effects.call)(filterRequirements, requirementData);

                case 28:
                    requirementSets = _context.sent;
                    _context.next = 31;
                    return (0, _effects.call)(_normalizr.normalize, requirementSets, (0, _normalizr.arrayOf)(_requirementSetSchema2.default));

                case 31:
                    _ref3 = _context.sent;
                    entities = _ref3.entities;
                    _context.next = 35;
                    return (0, _effects.call)(extractResourceData, entities.requirements || []);

                case 35:
                    _ref4 = _context.sent;
                    resources = _ref4.resources;
                    toPost = _ref4.toPost;

                    entities.resources = resources;
                    entities.toPost = toPost;

                    _context.next = 42;
                    return (0, _effects.put)((0, _requirementDataActions.requirementDataReceived)(entities));

                case 42:
                    if (!requestExtraResourceData) {
                        _context.next = 46;
                        break;
                    }

                    requestExtraResourceData = false;
                    _context.next = 46;
                    return [(0, _effects.put)((0, _customersDataActions.customersDataRequested)()), (0, _effects.put)((0, _departureServicesDataActions.departureServicesDataRequested)()), (0, _effects.put)((0, _profilesDataActions.profilesDataRequested)())];

                case 46:
                    _context.next = 50;
                    break;

                case 48:
                    _context.next = 50;
                    return (0, _effects.put)((0, _requirementDataActions.requirementDataRequestFailed)(error._error));

                case 50:
                    _context.next = 54;
                    break;

                case 52:
                    _context.next = 54;
                    return (0, _effects.put)((0, _bookingServicesActions.bookingServicesDataRequestFailed)("Failed to request booking services."));

                case 54:
                    _context.next = 1;
                    break;

                case 56:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

exports.default = fetchRequirementData;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/sagas/fetchRequirementData.js
// module id = 1416
// module chunks = 0